module.exports = __webpack_public_path__ + "img/pageM.23530ad0.png";